import React from "react";

import Nav from "../components/nav/Nav";

function NavigationBar(props: {groupName: string}) {
	return <Nav logo={`/api/organisations/${props.groupName}/theme/logo`} />;
}

export default NavigationBar;
